module.exports = __webpack_public_path__ + "static/media/work-img8.cefa6eff.jpg";